import React from 'react';

import hasMark from './utils/hasMark';
import hasBlock from './utils/hasBlock';

import collapseOnEscapePlugin from 'slate-collapse-on-escape';
import listsPlugin, { ListIcon, ListDepthIncreaseIcon, ListDepthDecreaseIcon } from './plugins/list.plugin';
import boldPlugin, { BoldIcon } from './plugins/bold.plugin';
import italicPlugin, { ItalicIcon } from './plugins/italic.plugin';
import underlinePlugin, { UnderlineIcon } from './plugins/underline.plugin';
import imagePlugin, { InsertImageButton } from './plugins/imagePlugin/image.plugin';
import lastPositionPlugin from './plugins/lastPosition.plugin';
import headersPlugin from './plugins/headers.plugin';
import indentationPlugin from './plugins/indentation.plugin';
import internalLinkPlugin, { InsertInternalLinkButton } from './plugins/internalLinkPlugin/internalLink.plugin';
import toolbarPlugin, { separator } from './plugins/toolbar.plugin';

const actions = [
  [
    {
      label: 'h1',
      icon: <div>H1</div>,
      action: editor => editor.toggleHeader(1),
      isActive: editor => editor.isHeader(1),
    },
    {
      label: 'h2',
      icon: <div>H2</div>,
      action: editor => editor.toggleHeader(2),
      isActive: editor => editor.isHeader(2),
    },
    {
      label: 'h3',
      icon: <div>H3</div>,
      action: editor => editor.toggleHeader(3),
      isActive: editor => editor.isHeader(3),
    },
    {
      label: 'h4',
      icon: <div>H4</div>,
      action: editor => editor.toggleHeader(4),
      isActive: editor => editor.isHeader(4),
    },
    {
      label: 'h5',
      icon: <div>H5</div>,
      action: editor => editor.toggleHeader(5),
      isActive: editor => editor.isHeader(5),
    },
    {
      label: 'h6',
      icon: <div>H6</div>,
      action: editor => editor.toggleHeader(6),
      isActive: editor => editor.isHeader(6),
    },
    separator,
    {
      label: 'Bold',
      icon: <BoldIcon size="1.5em" />,
      action: editor => editor.toggleBold(),
      isActive: editor => hasMark(editor.value, 'bold'),
    },
    {
      label: 'Italic',
      icon: <ItalicIcon size="1.5em" />,
      action: editor => editor.toggleItalic(),
      isActive: editor => hasMark(editor.value, 'italic'),
    },
    {
      label: 'Underline',
      icon: <UnderlineIcon size="1.5em" />,
      action: editor => editor.toggleUnderline(),
      isActive: editor => hasMark(editor.value, 'underline'),
    },
    separator,
    {
      label: 'Insert link',
      icon: editor => <InsertInternalLinkButton size="1.5em" editor={editor} />, // eslint-disable-line react/display-name
      isActive: true,
    },
    {
      label: 'Insert picture',
      icon: editor => <InsertImageButton size="1.5em" editor={editor} />, // eslint-disable-line react/display-name
      isActive: true,
    },
    separator,
    {
      label: 'Toggle list',
      icon: <ListIcon size="1.5em" />,
      action: editor => editor.toggleList(),
      isActive: true,
    },
    {
      label: 'Increase depth',
      icon: <ListDepthIncreaseIcon size="1.5em" />,
      action: editor => (hasBlock(editor.value, 'list-item-child')
        ? editor.increaseListItemDepth()
        : editor.increaseIndentation()),
      isActive: true,
    },
    {
      label: 'Decrease depth',
      icon: <ListDepthDecreaseIcon size="1.5em" />,
      action: editor => (hasBlock(editor.value, 'list-item-child')
        ? editor.decreaseListItemDepth()
        : editor.decreaseIndentation()),
      isActive: true,
    },
  ],
];


const { keymap: listsPluginKeymap, core: listsPluginCore } = listsPlugin();

export const plugins = [
  imagePlugin(),
  listsPluginCore,
  listsPluginKeymap,
  collapseOnEscapePlugin(),
  boldPlugin(),
  italicPlugin(),
  underlinePlugin(),
  lastPositionPlugin(),
  headersPlugin(),
  indentationPlugin(),
  internalLinkPlugin(),
  toolbarPlugin(actions),
];
